'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, (0, _extends3.default)({}, authActions, { replaceState: _reactRouterRedux.replace, pushState: _reactRouterRedux.push })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var input = _this.refs.username;
      var password = _this.refs.password;
      _this.props.login(input.value, password.value);
      input.value = '';
      password.value = '';
    };

    _this.componentWillMount = _this.componentWillMount.bind(_this);
    _this.componentWillReceiveProps = _this.componentWillReceiveProps.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.user) {
        // If logged in take to search page
        this.props.replaceState('/search');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user) {
        // If logged in take to search page
        nextProps.replaceState('/search');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout;

      var styles = require('./Login.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        !user && _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit },
          _react2.default.createElement(
            'h1',
            null,
            'Kuna Internal'
          ),
          _react2.default.createElement('input', {
            type: 'text',
            ref: 'username',
            placeholder: 'Email',
            className: 'username'
          }),
          _react2.default.createElement('input', {
            type: 'password',
            ref: 'password',
            placeholder: 'Password',
            className: 'password'
          }),
          _react2.default.createElement(
            'button',
            { type: 'submit', onClick: this.handleSubmit },
            ' Log In'
          )
        ),
        user && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'You are currently logged in as ',
            user.email,
            '.'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-danger', onClick: logout },
              _react2.default.createElement('i', { className: 'fa fa-sign-out' }),
              '   ',
              'Log Out'
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.backgroundImg })
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  replaceState: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = Login;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.js
 ** module id = 1396
 ** module chunks = 0
 **/